import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

export const rewritePostCopy = createAsyncThunk(
  "rewritePost/rewritePostCopy",
  async ({ clientId, payload }, { rejectWithValue }) => {
    try {
      if (!clientId) throw new Error("Client ID is required")
      if (!payload.currentDraft) throw new Error("Current draft text is required")

      const response = await post(`posts/clients/${clientId}/rewrite-post-copy`, payload)
      return response
    } catch (error) {
      console.error("Rewrite post error:", error)
      return rejectWithValue(error.message || "Failed to rewrite post")
    }
  },
)

const rewritePostSlice = createSlice({
  name: "rewritePost",
  initialState: {
    status: "idle",
    error: null,
    rewrittenText: null,
  },
  reducers: {
    resetRewriteState: (state) => {
      state.status = "idle"
      state.error = null
      state.rewrittenText = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rewritePostCopy.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(rewritePostCopy.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.rewrittenText = action.payload?.post_text || action.payload
      })
      .addCase(rewritePostCopy.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetRewriteState } = rewritePostSlice.actions
export default rewritePostSlice.reducer
